// @ts-nocheck
import React, { useCallback, useMemo, useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ReactComponent as SwapHorizIcon } from '../../../../../assets/Icons/lucideIcons/arrow-left-right.svg';

import {
  useTableState,
  useTableDispatch,
} from '../../../context/TableSchemaBuilderContext';
import ConfirmModal from '../../../../Common/Modals/ConfirmModal';

const UploadedFile = () => {
  const { schema, config } = useTableState();
  const dispatch = useTableDispatch();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  // Check if this is the constant attribute feature and if we have schema data
  const isFromConstAttributeFeature = config?.fromConstAttributeFeature;
  const hasSchemaData = schema?.cells && Object.keys(schema.cells).length > 0;

  // Determine the file name - could be from various sources
  const fileName = useMemo(() => {
    // Try to extract filename from schema metadata if available
    if (schema?.metadata?.fileName) {
      return schema.metadata.fileName;
    }

    // Fallback to a default filename
    if (hasSchemaData) {
      return 'uploaded_schema.xlsx';
    }

    return null;
  }, [schema?.metadata?.fileName, hasSchemaData]);

  const handleRemoveFile = useCallback(() => {
    setShowConfirmModal(true);
  }, [setShowConfirmModal]);

  const handleConfirmRemove = useCallback(() => {
    // Clear the schema by setting it to initial empty state
    const emptySchema = {
      rows: 6,
      columns: 10,
      cells: {},
      columnSettings: {},
      rowSettings: {},
      mergedCells: [],
    };

    dispatch({
      type: 'SET_SCHEMA',
      payload: emptySchema,
    });

    // Reset UI state
    dispatch({
      type: 'UPDATE_SELECTION',
      payload: {
        currentCell: 'A1',
        cells: ['A1'],
        anchorCell: 'A1',
      },
    });

    // Call the file removal callback if provided in config
    if (config?.onFileRemove && typeof config.onFileRemove === 'function') {
      config.onFileRemove();
    }

    setShowConfirmModal(false);
  }, [dispatch, config, setShowConfirmModal]);

  const handleCloseConfirmModal = useCallback(() => {
    setShowConfirmModal(false);
  }, [setShowConfirmModal]);

  // Only show the component if it's from constant attribute feature and has schema data
  if (!isFromConstAttributeFeature || !hasSchemaData || !fileName) {
    return null;
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          padding: '4px 8px',
          border: 1,
          borderRadius: 1,
          minWidth: 200,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {fileName}
        </Typography>
        <IconButton size="small" onClick={handleRemoveFile} title="Change file">
          <SwapHorizIcon />
        </IconButton>
      </Box>

      <ConfirmModal
        open={showConfirmModal}
        handleClose={handleCloseConfirmModal}
        confirm={handleConfirmRemove}
        cancel={handleCloseConfirmModal}
        alertLabelText="Are you sure you want to change this uploaded file?"
        confirmButtonLabel="Yes"
        cancelButtonLabel="Cancel"
        resourceName="Change Uploaded File"
      />
    </>
  );
};

export default UploadedFile;
